import {getDocumentName} from '../../../utils/document';
import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

const DOCUMENT_PATH = `${pathHelpContentFile}it/IT_MOD_DELEG/${getDocumentName('Délégation de pouvoirs Once For All')}.docx`;

export default {
  id: 'MOD_DELEG',
  title: 'Un modello di delega di potere?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Per aggiornare il permesso di firma, prendere il seguente modello:'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: DOCUMENT_PATH,
    label: 'Delega di potere.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Restituisci il documento compilato e firmato con il tuo documento d\'identità a servizio.clienti@onceforall.com.'
  }]
};
